import { CountUp } from 'countup.js';

export class NewDefaultModules {

  constructor (el) {
    this.el = el
    this.numbersSectionTrigger = false
    this.init()
  }

  init() {
    console.log('NewDefaultModules init')
    this.initScrollTriggers()
  }

  /**
   * Scroll triggers
   */

  initScrollTriggers () {
    jQuery(window).on('scroll', ()=>{ 
      if (this.elementInView(jQuery('.numbers-columns .columns-wrapper .item', this.el).get(0))) {
        this.initCountUp('.numbers-columns', this.numbersSectionTrigger);
      } else {
        this.numbersSectionTrigger = false;
      }
    })
  }

  onScroll () {
    jQuery.each(this.jQueryscrollEls, (i,el)=>{
      jQuery(el).toggleClass('ar2022-scroll-in-view', this.elementInView(el))
    })
  }

  elementInView (el) {
    let box = el.getBoundingClientRect(),
    elTop = box.top,
    elBot = box.bottom,
    winH = window.innerHeight
    return ( elTop < (winH * 0.95) && elBot > (winH * 0.05) )
    }

  /**
   * CountUps
   */

  initCountUp (selector, trigger) {
    this.countUp = jQuery(selector + ' [data-countup]', this.el)   
    if (!trigger) {
      jQuery.each(this.countUp, (i,el)=>{
        let data = jQuery(el).data('countup'),
            prefix = data[1] || '',
            suffix = data[2] || '',
            value = data[0],
            decimalPlaces = this.countDecimals(value)
        new CountUp( jQuery(el).get(0), value, {
          decimalPlaces: decimalPlaces,
          prefix: prefix,
          suffix: suffix,
          duration: 2,
        } ).start()
      })
      this.numbersSectionTrigger = true;
    } 
  }
  
  countDecimals (value) {
    if (Math.floor(value) !== value) {
      return value.toString().split(".")[1].length || 0;
    }
    return 0;
  }

}